import { render, staticRenderFns } from "./AsideBase.vue?vue&type=template&id=65626809&scoped=true&"
import script from "./AsideBase.vue?vue&type=script&lang=js&"
export * from "./AsideBase.vue?vue&type=script&lang=js&"
import style0 from "./AsideBase.vue?vue&type=style&index=0&id=65626809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65626809",
  null
  
)

export default component.exports